(() => {
  const endpoint = 'https://archie-ii-production.up.railway.app/api/website-settings?shop=yvrcookie.myshopify.com';
  const hero = document.querySelector('[data-yvr-website-hero]');
  const revealHero = () => {
    if (!hero || hero.hidden) return;
    const image = hero.querySelector('[data-yvr-hero-slide].is-active img');
    const reveal = () => hero.removeAttribute('data-yvr-hero-pending');
    if (!image || (image.complete && image.naturalWidth > 0)) { reveal(); return; }
    const fallback = setTimeout(reveal, 2000);
    const finish = () => { clearTimeout(fallback); reveal(); };
    if (typeof image.decode === 'function') image.decode().catch(() => {}).then(finish);
    else {
      image.addEventListener('load', finish, { once: true });
      image.addEventListener('error', finish, { once: true });
    }
  };
  const banner = document.querySelector('[data-yvr-website-banner]');
  if (!banner || banner.dataset.initialized === 'true') return;
  banner.dataset.initialized = 'true';
  const normalizeBannerPath = value => {
    try { return decodeURI(value).replace(/\/+$/, '') || '/'; } catch (_) { return value.replace(/\/+$/, '') || '/'; }
  };
  const bannerPathMatches = (path, pattern) => {
    const normalized = normalizeBannerPath(path);
    if (pattern.endsWith('/*')) {
      const prefix = normalizeBannerPath(pattern.slice(0, -2));
      return prefix === '/' || normalized === prefix || normalized.startsWith(`${prefix}/`);
    }
    return normalized === normalizeBannerPath(pattern);
  };
  const bannerPageAllowed = settings => {
    const root = normalizeBannerPath(banner.dataset.rootUrl || '/');
    const path = normalizeBannerPath(location.pathname);
    const localizedPath = root !== '/' && (path === root || path.startsWith(`${root}/`)) ? path.slice(root.length) || '/' : path;
    const homepage = banner.dataset.homepage === 'true';
    const inScope = settings.displayScope === 'all' || homepage;
    return settings.enabled !== false && inScope && !(Array.isArray(settings.excludedPaths) && settings.excludedPaths.some(pattern => typeof pattern === 'string' && (bannerPathMatches(path, pattern) || bannerPathMatches(localizedPath, pattern))));
  };
  const dismissalKey = 'yvr-website-banner-dismissed-at';
  const dismissalDuration = value => Number.isInteger(Number(value)) && Number(value) >= 1 && Number(value) <= 365 ? Number(value) : 1;
  const dismissalIsActive = (timestamp, days, now = Date.now()) => Number.isFinite(timestamp) && timestamp > 0 && timestamp <= now && now - timestamp < dismissalDuration(days) * 86400000;
  let dismissedAt = 0;
  let dismissalDays = 1;
  let bannerAvailable = false;
  let bannerDismissed = false;
  let stopBanner = () => {};
  let resumeBanner = () => {};
  try { dismissedAt = Number(localStorage.getItem(dismissalKey)) || 0; } catch (_) {}
  try {
    if (sessionStorage.getItem('yvr-website-banner-dismissed') === '1') {
      if (!dismissedAt) {
        dismissedAt = Date.now();
        try { localStorage.setItem(dismissalKey, String(dismissedAt)); } catch (_) {}
      }
      sessionStorage.removeItem('yvr-website-banner-dismissed');
    }
  } catch (_) {}
  const refreshBannerVisibility = () => {
    bannerDismissed = dismissalIsActive(dismissedAt, dismissalDays);
    banner.hidden = !bannerAvailable || bannerDismissed;
    if (banner.hidden) stopBanner();
    else resumeBanner();
  };
  refreshBannerVisibility();
  banner.querySelector('[data-yvr-banner-close]').addEventListener('click', () => {
    dismissedAt = Date.now();
    try { localStorage.setItem(dismissalKey, String(dismissedAt)); } catch (_) {}
    refreshBannerVisibility();
  });
  window.addEventListener('pageshow', refreshBannerVisibility);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refreshBannerVisibility(); });
  window.addEventListener('storage', event => {
    if (event.key !== dismissalKey && event.key !== null) return;
    try { dismissedAt = Number(localStorage.getItem(dismissalKey)) || 0; } catch (_) {}
    refreshBannerVisibility();
  });
  const removeLegacyTicker = () => document.getElementById('yeps')?.remove();
  removeLegacyTicker();
  new MutationObserver(removeLegacyTicker).observe(document.body, { childList: true });
  const motionPreference = matchMedia('(prefers-reduced-motion: reduce)');
  if (!motionPreference.matches && 'IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      });
    }, { threshold: .12, rootMargin: '0px 0px -24px 0px' });
    document.querySelectorAll('.yvr-website-intro [data-yvr-reveal]').forEach(element => {
      element.classList.add('is-reveal-ready');
      revealObserver.observe(element);
    });
  }

  const safeImageUrl = (value) => {
    try {
      const url = new URL(value);
      return url.protocol === 'https:' ? url.href : '';
    } catch (_) { return ''; }
  };
  const safeLink = (value) => {
    if (typeof value !== 'string' || !value.trim()) return '';
    if (value.startsWith('/') && !value.startsWith('//')) return value;
    try {
      const url = new URL(value);
      return url.protocol === 'https:' ? url.href : '';
    } catch (_) { return ''; }
  };
  const safePosition = (value) => /^\d{1,3}%\s+\d{1,3}%$/.test(String(value || '')) ? value : '50% 50%';
  const rotationMs = (value) => Number.isFinite(Number(value)) && Number(value) > 0
    ? Math.min(60000, Math.max(3000, Number(value) * 1000)) : 8000;
  const sortedEnabled = (items) => Array.isArray(items)
    ? items.filter(item => item && item.enabled !== false).sort((a, b) => Number(a.order || 0) - Number(b.order || 0))
    : [];

  function setupHeroSwipe(root, changeSlide, pause, resume) {
    let swipe = null;
    let suppressClickUntil = 0;
    root.addEventListener('touchstart', event => {
      suppressClickUntil = 0;
      if (swipe) { swipe = null; resume(); }
      if (!matchMedia('(max-width: 749px)').matches || event.touches.length !== 1 || event.target.closest('button, .yvr-website-hero__actions')) return;
      const touch = event.touches[0];
      swipe = { id: touch.identifier, x: touch.clientX, y: touch.clientY, axis: null };
      pause();
    }, { passive: true });
    root.addEventListener('touchmove', event => {
      if (!swipe) return;
      if (event.touches.length !== 1) { swipe = null; resume(); return; }
      const touch = Array.from(event.touches).find(item => item.identifier === swipe.id);
      if (!touch) return;
      const dx = Math.abs(touch.clientX - swipe.x), dy = Math.abs(touch.clientY - swipe.y);
      if (!swipe.axis && Math.max(dx, dy) >= 4) swipe.axis = dx >= dy * .85 ? 'horizontal' : 'vertical';
      if (swipe.axis === 'vertical') { swipe = null; resume(); return; }
      if (swipe.axis === 'horizontal' && event.cancelable) event.preventDefault();
    }, { passive: false });
    root.addEventListener('touchend', event => {
      if (!swipe) return;
      const touch = Array.from(event.changedTouches).find(item => item.identifier === swipe.id);
      if (!touch) return;
      const dx = touch.clientX - swipe.x, dy = touch.clientY - swipe.y;
      const horizontal = swipe.axis === 'horizontal' || !swipe.axis && Math.abs(dx) >= Math.abs(dy) * .85;
      swipe = null;
      if (Math.max(Math.abs(dx), Math.abs(dy)) >= 10) suppressClickUntil = Date.now() + 400;
      if (horizontal && Math.abs(dx) >= 32) changeSlide(dx < 0 ? 1 : -1);
      resume();
    }, { passive: true });
    root.addEventListener('touchcancel', () => {
      if (!swipe) return;
      swipe = null;
      resume();
    }, { passive: true });
    root.addEventListener('click', event => {
      if (event.detail === 0 || Date.now() >= suppressClickUntil) return;
      event.preventDefault();
      event.stopPropagation();
    }, true);
  }

  function setupCarousel(root, slideSelector, dotContainer, previous, next, intervalMs) {
    const slides = [...root.querySelectorAll(slideSelector)];
    let active = 0;
    let timer;
    const controls = root.querySelector('[data-yvr-hero-controls]');
    const show = (index) => {
      if (!slides.length) return;
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === active);
        slide.setAttribute('aria-hidden', i === active ? 'false' : 'true');
        slide.inert = i !== active;
      });
      [...dotContainer.children].forEach((dot, i) => {
        dot.classList.toggle('is-active', i === active);
        dot.setAttribute('aria-current', i === active ? 'true' : 'false');
      });
    };
    const start = () => {
      clearInterval(timer);
      if (slides.length > 1 && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        timer = setInterval(() => show(active + 1), intervalMs);
      }
    };
    dotContainer.replaceChildren(...slides.map((_, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
      dot.addEventListener('click', () => { show(i); start(); });
      return dot;
    }));
    if (previous) previous.onclick = () => { show(active - 1); start(); };
    if (next) next.onclick = () => { show(active + 1); start(); };
    if (controls) controls.hidden = slides.length < 2;
    dotContainer.hidden = slides.length < 2;
    root.addEventListener('mouseenter', () => clearInterval(timer));
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', () => clearInterval(timer));
    root.addEventListener('focusout', event => { if (!root.contains(event.relatedTarget)) start(); });
    if (slides.length > 1) setupHeroSwipe(root, delta => show(active + delta), () => clearInterval(timer), start);
    show(0);
    start();
  }

  function heroSlide(item, index) {
    const desktop = safeImageUrl(item.desktop?.url);
    const mobile = safeImageUrl(item.mobile?.url);
    if (!desktop || !mobile) return null;
    const slide = document.createElement('div');
    slide.className = 'yvr-website-hero__slide';
    slide.setAttribute('data-yvr-hero-slide', '');
    slide.style.setProperty('--desktop-position', safePosition(item.desktop.position));
    slide.style.setProperty('--mobile-position', safePosition(item.mobile.position));
    const picture = document.createElement('picture');
    const source = document.createElement('source');
    source.media = '(max-width: 749px)';
    source.srcset = mobile;
    const image = document.createElement('img');
    image.src = desktop;
    image.alt = String(item.desktop.alt || item.mobile.alt || 'Featured YVR Cookie');
    image.width = 1920;
    image.height = 986;
    image.loading = index === 0 ? 'eager' : 'lazy';
    if (index === 0) image.fetchPriority = 'high';
    picture.append(source, image);
    const link = safeLink(item.link);
    if (link) {
      const anchor = document.createElement('a');
      anchor.href = link;
      anchor.setAttribute('aria-label', image.alt);
      anchor.append(picture);
      slide.append(anchor);
    } else slide.append(picture);
    return slide;
  }

  const safeColor = (value, fallback) => /^#[0-9a-f]{6}$/i.test(String(value || '')) ? value.toUpperCase() : fallback;
  const contrast = (first, second) => {
    const luminance = hex => {
      const rgb = [1, 3, 5].map(index => parseInt(hex.slice(index, index + 2), 16) / 255)
        .map(channel => channel <= .04045 ? channel / 12.92 : ((channel + .055) / 1.055) ** 2.4);
      return .2126 * rgb[0] + .7152 * rgb[1] + .0722 * rgb[2];
    };
    const values = [luminance(first), luminance(second)].sort((a, b) => b - a);
    return (values[0] + .05) / (values[1] + .05);
  };

  function renderBannerEntry(item) {
    if (item.type && item.type !== 'text') return null;
    if (typeof item.text !== 'string' || !item.text.trim()) return null;
    const entry = document.createElement('div');
    entry.className = 'yvr-website-banner__entry';
    entry.setAttribute('data-yvr-banner-entry', '');
    const background = safeColor(item.backgroundColor, '#754B2C');
    let textColor = safeColor(item.textColor, '#FFFFFF');
    if (contrast(background, textColor) < 4.5) textColor = contrast(background, '#000000') >= 4.5 ? '#000000' : '#FFFFFF';
    let buttonColor = safeColor(item.buttonBackgroundColor, '#FFFFFF');
    let buttonText = safeColor(item.buttonTextColor, '#754B2C');
    if (contrast(buttonColor, background) < 3) buttonColor = textColor;
    if (contrast(buttonColor, buttonText) < 4.5) buttonText = contrast(buttonColor, '#000000') >= 4.5 ? '#000000' : '#FFFFFF';
    entry.style.setProperty('--yvr-banner-background', background);
    entry.style.setProperty('--yvr-banner-text', textColor);
    entry.style.setProperty('--yvr-banner-button', buttonColor);
    entry.style.setProperty('--yvr-banner-button-text', buttonText);
    entry.style.setProperty('--yvr-banner-button-hover', contrast(buttonColor, background) >= 4.5 ? buttonColor : textColor);
    const content = document.createElement('div');
    content.className = 'yvr-website-banner__content';
    const text = document.createElement('p');
    text.className = 'yvr-website-banner__text';
    text.textContent = item.text;
    content.append(text);
    const link = safeLink(item.ctaLink);
    const label = typeof item.ctaLabel === 'string' ? item.ctaLabel.trim() : '';
    if (link && label) {
      const anchor = document.createElement('a');
      anchor.className = 'yvr-website-banner__cta yvr-cta yvr-cta--primary';
      anchor.href = link;
      anchor.textContent = label;
      content.append(anchor);
    }
    entry.append(content);
    return entry;
  }

  function setupBanner(intervalMs) {
    const entriesRoot = banner.querySelector('[data-yvr-banner-entries]');
    const slides = [...entriesRoot.querySelectorAll('[data-yvr-banner-entry]')];
    let active = 0;
    let requested = !motionPreference.matches;
    let hovering = false;
    let focused = false;
    let timer;
    const multiple = slides.length > 1;
    stopBanner = () => { clearTimeout(timer); banner.dataset.rotationState = 'stopped'; };
    const schedule = () => {
      clearTimeout(timer);
      const rotating = multiple && requested && !hovering && !focused && !document.hidden && !banner.hidden && !bannerDismissed;
      banner.dataset.rotationState = rotating ? 'playing' : 'paused';
      if (rotating) timer = setTimeout(() => { show(active + 1); schedule(); }, intervalMs);
    };
    const show = index => {
      if (!slides.length) return;
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, position) => {
        slide.classList.toggle('is-active', position === active);
        slide.setAttribute('aria-hidden', position === active ? 'false' : 'true');
        slide.inert = position !== active;
        slide.setAttribute('role', 'group');
        slide.setAttribute('aria-roledescription', 'slide');
        slide.setAttribute('aria-label', `${position + 1} of ${slides.length}`);
      });
      ['--yvr-banner-background', '--yvr-banner-text'].forEach(property => {
        const color = slides[active].style.getPropertyValue(property);
        if (color) banner.style.setProperty(property, color);
      });
    };
    banner.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { hovering = true; schedule(); } });
    banner.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse') { hovering = false; schedule(); } });
    banner.addEventListener('focusin', () => { focused = true; schedule(); });
    banner.addEventListener('focusout', event => { if (!banner.contains(event.relatedTarget)) { focused = false; schedule(); } });
    document.addEventListener('visibilitychange', schedule);
    motionPreference.addEventListener('change', event => { requested = !event.matches; schedule(); });
    resumeBanner = schedule;
    show(0);
    schedule();
  }

  const settingsRequest = new AbortController();
  const settingsTimeout = setTimeout(() => settingsRequest.abort(), 6000);
  fetch(endpoint, { credentials: 'omit', mode: 'cors', cache: 'no-store', signal: settingsRequest.signal })
    .then(response => { if (!response.ok) throw Error(`Website settings: ${response.status}`); return response.json(); })
    .then(settings => {
      if (![1, 2].includes(settings?.schemaVersion)) throw Error('Unsupported website settings');
      if (hero && settings.homepage?.enabled === false) hero.hidden = true;
      else if (hero) {
        const slides = sortedEnabled(settings.homepage?.slides).map(heroSlide).filter(Boolean);
        if (slides.length) hero.querySelector('[data-yvr-hero-slides]').replaceChildren(...slides);
        else if (Array.isArray(settings.homepage?.slides)) hero.hidden = true;
      }
      dismissalDays = dismissalDuration(settings.banner?.dismissalDays);
      banner.dataset.sticky = String(settings.banner?.sticky === true);
      banner.dataset.pushPageDown = String(settings.banner?.pushPageDown !== false);
      bannerAvailable = bannerPageAllowed(settings.banner || {});
      if (!bannerAvailable) banner.hidden = true;
      else {
        const entries = sortedEnabled(settings.banner?.entries).map(renderBannerEntry).filter(Boolean);
        if (entries.length) {
          banner.querySelector('[data-yvr-banner-entries]').replaceChildren(...entries);
        } else if (Array.isArray(settings.banner?.entries)) bannerAvailable = false;
      }
      if (hero && !hero.hidden) setupCarousel(hero, '[data-yvr-hero-slide]', hero.querySelector('[data-yvr-hero-dots]'), hero.querySelector('[data-yvr-hero-previous]'), hero.querySelector('[data-yvr-hero-next]'), rotationMs(settings.homepage?.rotationSeconds));
      refreshBannerVisibility();
      setupBanner(rotationMs(settings.banner?.rotationSeconds));
    })
    .catch(() => {
      if (hero) setupCarousel(hero, '[data-yvr-hero-slide]', hero.querySelector('[data-yvr-hero-dots]'), hero.querySelector('[data-yvr-hero-previous]'), hero.querySelector('[data-yvr-hero-next]'), 8000);
      bannerAvailable = false;
      refreshBannerVisibility();
    })
    .finally(() => { clearTimeout(settingsTimeout); revealHero(); });
})();
